export default __webpack_public_path__ + "static/media/evento-5.53621120.jpg";